import { SID_COMMON_BASE_URL } from 'Modules/shareholders-id/constants';

export default {
  transclude: true,
  templateUrl: `${SID_COMMON_BASE_URL}/components/page-content-tile/page-content-tile.template.html`,
};
